import styled from 'styled-components';

interface ChartLabelProps {
  pointColor: string;
  text: string;
}

const ChartLabel = ({ pointColor, text }: ChartLabelProps) => {
  return (
    <Label>
      <Point style={{ background: pointColor }}></Point>
      <Text>{text}</Text>
    </Label>
  );
};

export default ChartLabel;

const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Point = styled.p`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  outline-color: rgba(0, 0, 0, 0.2);
  outline-width: thin;
  outline-style: solid;
`;

const Text = styled.p`
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
`;
